// src/services/profileService.js
import { apiRequest } from "./apiService";

const isNotFound404 = (err) => {
  const msg = String(err?.message || err || "");
  return msg.includes("Request failed: 404") || msg.includes("404 Not Found") || msg.includes("404");
};

// Convert camelCase -> snake_case for backend safety
const toSnakeProfile = (p) => {
  if (!p || typeof p !== "object") return p;

  // If caller already provided snake_case, keep it.
  const hasSnake = "family_name" in p || "account_type" in p || "business_size" in p;
  if (hasSnake) return p;

  return {
    family_name: p.familyName ?? null,
    birthdate: p.birthdate ?? null,
    account_type: p.accountType ?? null,
    industry: p.industry ?? null,
    interests: p.interests ?? null,
    business_size: p.businessSize ?? null,
    location: p.location ?? null,
    goal: p.goal ?? null,
    preferred_communication: p.preferredCommunication ?? null,
  };
};

// Convert snake_case -> camelCase for frontend consistency
const toCamelProfile = (p) => {
  if (!p || typeof p !== "object") return p;

  const hasCamel = "familyName" in p || "accountType" in p || "businessSize" in p;
  if (hasCamel) return p;

  return {
    familyName: p.family_name ?? "",
    birthdate: p.birthdate ?? "",
    accountType: p.account_type ?? "",
    industry: p.industry ?? "",
    interests: p.interests ?? "",
    businessSize: p.business_size ?? "",
    location: p.location ?? "",
    goal: p.goal ?? "",
    preferredCommunication: p.preferred_communication ?? "",
  };
};

/**
 * Backend:
 *  - GET  /profile
 *  - POST /profile
 *  - PUT  /profile
 *  - GET  /profile/api-usage
 */

export const fetchUserProfile = async () => {
  try {
    const res = await apiRequest("/profile", "GET");

    // allow wrappers
    const obj = res?.profile ?? res?.user ?? res;
    return obj ? toCamelProfile(obj) : null;
  } catch (err) {
    // ✅ If profile doesn't exist yet, treat as "no profile", NOT an error
    if (isNotFound404(err)) return null;
    throw err;
  }
};

export const createUserProfile = async (profileData) => {
  const payload = toSnakeProfile(profileData);
  const res = await apiRequest("/profile", "POST", payload);

  // Some handlers return {message}, some return profile
  const obj = res?.profile ?? res?.user ?? res;
  return obj ? toCamelProfile(obj) : res;
};

export const updateUserProfile = async (profileData) => {
  const payload = toSnakeProfile(profileData);
  const res = await apiRequest("/profile", "PUT", payload);

  const obj = res?.profile ?? res?.user ?? res;
  return obj ? toCamelProfile(obj) : res;
};

export const fetchProfileApiUsage = () => apiRequest("/profile/api-usage", "GET");
